import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Banner from './Banner';
import HighLights from './Highlights';
import Reviews from './Reviews';
import Salary from './Salary';
import Enroll from './Enroll';
import Cirriculum from './Curriculum';
import DownloadForm from './DownloadForm';

import Emi from './Emi';
import LevelGroup from './Levels';

import Modal from '../../Components/Modal';
import BlurBox from '../../Components/BlurBox';
import VideoPlayer from '../../Components/VideoPlayer';
import CourseBuyForm from '../Course/CourseBuyForm';
import LazyComponent from '../../Components/LazyComponent';
import Meta from '../../Components/Meta';

import ToolsToLearn from './ToolsToLearn';
import CollaboratedCompanies from './CollaboratedCompanies';

import {
  getCourseTitleAndDescription,
  getCourseLevelFeedbacks,
  getCourseLevelCompanies,
  getCourseLevelData,
  getCurrentCourseLevelId,
  getCurrentCourse,
  getAllCourseLevels,
  getCourseToolsImages,
  getCourseLevelLiveProjects,
  getAllLevelLinkedData
} from '../../selectors/course';

import {
  changeCourseLevel,
  fetchCurrentCourseCourseLevel
} from '../../actions/courseLevel';
import { fetchCurrentCourse, updateCourseKey } from '../../actions/course';

import { SITE_URL } from '../../config.local';

import './style.css';
class LiveClass extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      downloadFormActive: false,
      registrationFormActive: false,
      videoPlayerActive: false,
      emiModalActive: false,
      currentCourseDuration: '',
      isLoading: false
    };
    const { courseKey } = this.props.match.params;
    this.pageMetaDescription = this.getMetaDescription(courseKey);
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    try {
      const { courseKey } = this.props.match.params;
      this.props.updateCourseKey(courseKey);

      const promises = [this.props.fetchCurrentCourseCourseLevel(courseKey)];
      if (this.props.currentCourseData === null) {
        promises.push(this.props.fetchCurrentCourse(courseKey));
      }

      this.toggleLoading();
      await Promise.all(promises);
      this.toggleLoading();
    } catch (err) {
      this.toggleLoading();
    }
  };

  toggleLoading = () => {
    this.setState(prevState => ({
      isLoading: !prevState.isLoading
    }));
  };

  toggleEmiModal = () => {
    this.setState(prevState => ({
      emiModalActive: !prevState.emiModalActive
    }));
  };

  toggleDownloadForm = () => {
    this.setState(prevState => ({
      downloadFormActive: !prevState.downloadFormActive
    }));
  };

  toggleVideoPlayer = () => {
    this.setState(prevState => ({
      videoPlayerActive: !prevState.videoPlayerActive
    }));
  };

  toggleRegistrationForm = () => {
    this.setState(prevState => ({
      registrationFormActive: !prevState.registrationFormActive
    }));
  };

  changeLevel = e => {
    const { id } = e.target.dataset;
    this.props.changeCourseLevel(id);
  };

  changeCourseDuration = time => {
    this.setState({
      currentCourseDuration: time
    });

    this.toggleRegistrationForm();
  };

  getMetaDescription = courseKey => {
    switch (courseKey) {
      case 'FSWD':
        return 'Become an expert in Full Stack Web Development. Get Front End and Back End Development Guidance by industry professionals using the technology of your choice.';
      case 'ML':
        return "Become a Machine Learning expert. Learn and get trained from the best industry professionals. Let's learn how you can teach the machine to learn.";
      case 'D&A':
        return "If competitive coding and cracking top companies' interviews are your goals, and you need a mentor then, this classroom course is the right place for you. ";
      case 'REACT':
        return 'Become a React JS/React Native expert learning from industry professionals. The most sought out JS library for web and mobile Front-End; developed by Facebook';
      case 'PY':
        return "If you aren't lazy, this course isn't for you. If you are, then go ahead, you might get amazed with the cool stuff. Become an expert in python programming. ";
      case 'AJ':
        return 'Learn Advance Java courses from experienced professionals in our 1 to 1 mentorship program. Make the best use of Summer & Winter Training after semester.';
      case 'PPT':
        return 'Special program designed consulting with recruiters of 10+ companies, and if you were looking for best revision before placement, this is the place to look for.';
      case 'R':
        return 'Learn the basics and build your foundation in Data Science with R programming language. Experienced Professionals, 1:1 Mentorship with several other opportunities. ';
      default:
        return '';
    }
  };

  render() {
    const {
      courseTitle,
      // courseDescription,
      // currentCourseLevelId,
      courseLevelData,
      levelFeedbacks,
      levelCompanies,
      // liveProjects,
      courseTools,
      courseLevels,
      currentCourseData,
      allLevelLinkedData
    } = this.props;

    const { highlights, highlightsUrl } = courseLevelData || {};
    const {
      sallary = 0,
      scopes = [],
      videoUrl = '',
      broucherUrl,
      notes,
      salaryGraphUrl
    } = currentCourseData || {};

    const {
      downloadFormActive,
      registrationFormActive,
      videoPlayerActive,
      emiModalActive,
      currentCourseDuration,
      isLoading
    } = this.state;

    return (
      <React.Fragment>
        <Meta
          title={`${courseTitle} | Alien Brains Educations`}
          description={this.pageMetaDescription}
        />
        <BlurBox loading={isLoading}>
          <Banner
            title={courseTitle}
            description={
              courseLevels[0] && courseLevels[0].about
                ? courseLevels[0].about
                : ''
            }
            toggleDownloadForm={this.toggleDownloadForm}
            toggleRegistrationForm={this.toggleRegistrationForm}
            toogleVideoPlayer={this.toggleVideoPlayer}
            toogleEmiModal={this.toggleEmiModal}
          />

          <LazyComponent>
            <HighLights highlights={highlights} images={highlightsUrl} />
          </LazyComponent>

          <LazyComponent>
            <LevelGroup
              note={notes}
              onLevelClick={this.changeCourseDuration}
              levels={courseLevels}
              linkedData={allLevelLinkedData}
            />
          </LazyComponent>

          {/* <LazyComponent>
        <Outcomes outcomes={outcomes}/>
        </LazyComponent> */}

          {/* <LazyComponent>
          <Projects projects={liveProjects}/>
        </LazyComponent> */}

          <LazyComponent>
            <CollaboratedCompanies companies={levelCompanies} />
          </LazyComponent>

          <LazyComponent>
            <Cirriculum toggleDownloadForm={this.toggleDownloadForm} />
          </LazyComponent>

          <LazyComponent>
            <Reviews reviews={levelFeedbacks} />
          </LazyComponent>

          <LazyComponent>
            <ToolsToLearn tools={courseTools} />
          </LazyComponent>

          <LazyComponent>
            <Salary
              salaryGraphUrl={salaryGraphUrl}
              courseTitle={courseTitle}
              sallary={sallary}
              scopes={scopes}
            />
          </LazyComponent>

          <LazyComponent>
            <Enroll
              toggleDownloadForm={this.toggleDownloadForm}
              toggleRegistrationForm={this.toggleRegistrationForm}
            />
          </LazyComponent>

          {/* <SideButtonGrp>
          {courseLevels.map(item => (
                <button 
                style={{
                  opacity:currentCourseLevelId === item.id ? 1 : 0.5,
                  boxShadow: currentCourseLevelId === item.id ? '2px 2px 10px 0px rgba(0, 0, 0, 0.5)': 'none'

                }} 
                data-id={item.id} 
                onClick={this.changeLevel} 
                key={item.id}>
                  {item.name}
                </button>
              ))
          }
        </SideButtonGrp> */}
        </BlurBox>

        <Modal active={downloadFormActive}>
          <DownloadForm
            broucherUrl={`${SITE_URL}/${broucherUrl}`}
            toggleForm={this.toggleDownloadForm}
          />
        </Modal>

        <Modal
          slideIn={true}
          transparent={false}
          toogleModal={this.toggleRegistrationForm}
          active={registrationFormActive}>
          <CourseBuyForm
            closeModal={this.toggleRegistrationForm}
            currentCourseDuration={currentCourseDuration}
            courseName={courseTitle}
            courseLevels={courseLevels}
          />
        </Modal>

        <VideoPlayer
          src={videoUrl}
          active={videoPlayerActive}
          togglePlayer={this.toggleVideoPlayer}
        />

        <Emi active={emiModalActive} toogleEmiModal={this.toggleEmiModal} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (store, props) => {
  const { title, description } = getCourseTitleAndDescription(store, props);
  return {
    courseTitle: title,
    courseDescription: description,
    currentCourseData: getCurrentCourse(store, props),
    currentCourseLevelId: getCurrentCourseLevelId(store, props),
    courseLevels: getAllCourseLevels(store, props),
    courseLevelData: getCourseLevelData(store, props),
    levelFeedbacks: getCourseLevelFeedbacks(store, props),
    levelCompanies: getCourseLevelCompanies(store, props),
    courseTools: getCourseToolsImages(store, props),
    liveProjects: getCourseLevelLiveProjects(store, props),
    allLevelLinkedData: getAllLevelLinkedData(store, props)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchCurrentCourseCourseLevel,
      fetchCurrentCourse,
      changeCourseLevel,
      updateCourseKey
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveClass);



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/index.js